import styled from 'styled-components';
import { DEVICES, pickThemeColor, pickThemeFontStyles } from '@/theme';

export const StyledTitle = styled.h1`
  ${pickThemeFontStyles('26', '28', 'SEMI_BOLD')};
  color: ${pickThemeColor('DARK_PURPLE')};
  text-align: center;
  padding: 0 1rem;
  margin-top: 2rem;

  @media screen and ${DEVICES.LAPTOP_S} {
    text-align: left;
    margin-top: 0;
    padding: 0;

    ${pickThemeFontStyles('40', '48', 'SEMI_BOLD')};
  }
`;

export const StyledContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  min-height: 100%;
  padding: 0;

  @media screen and ${DEVICES.LAPTOP_S} {
    padding: 2rem 6.25rem;
  }
`;

export const StyledContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  max-width: 60.5rem;
  margin: 0 auto;
`;

export const StyledWrapper = styled.div`
  position: relative;

  @media screen and ${DEVICES.LAPTOP_S} {
    padding: 1.5rem;
    margin: 1rem auto;
  }
`;

export const StyledBackButton = styled.div`
  &&& .back-button {
    margin-left: 1rem;
    margin-bottom: 1rem;

    @media screen and ${DEVICES.LAPTOP_S} {
      margin-left: 0;
    }
  }
`;

export const StyledText = styled.div`
  ${pickThemeFontStyles('16', '26')};
  color: ${pickThemeColor('BLACK_PRIMARY')};
  span,
  b {
    color: ${pickThemeColor('ORANGE_PRIMARY')};
  }

  b {
    ${pickThemeFontStyles('16', '26', 'BOLD')};
  }
`;

export const StyledDescription = styled.div`
  ${pickThemeFontStyles('16', '26')};
  color: ${pickThemeColor('BLACK_PRIMARY')};
`;
